import { render, staticRenderFns } from "./contractEdit2.vue?vue&type=template&id=01974bf2&scoped=true&"
import script from "./contractEdit2.vue?vue&type=script&lang=js&"
export * from "./contractEdit2.vue?vue&type=script&lang=js&"
import style0 from "./contractEdit2.vue?vue&type=style&index=0&id=01974bf2&scoped=true&lang=css&"
import style1 from "./contractEdit2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01974bf2",
  null
  
)

export default component.exports